import React from "react";
import { ProfileBG } from "../../Assests/Assests";
import useSeo from "../../utils/useSeo";

const Refunds = () => {
  useSeo({
    title: "Refund Policy | Riymay",
    description:
      "Riymay's refund and replacement policy for manufacturing defects, including how to report an issue and what happens next.",
    path: "/refunds",
  });
  return (
    <div className="shipping-policy-container refund-container">
      <div className="image-container">
        <div className="image-text">Refund Policy</div>
      </div>
      <div className="shipping-text">
        <p>We want you to love what you receive.</p>
        <p>
          In the rare case of a manufacturing defect, we've got you covered — reach out to us
          within 48 hours of delivery with your order number and all photographs, and we'll
          arrange a return or replacement at no cost to you.
        </p>
        <p>
          <strong>Please note:</strong> All return photographs must be original and unedited.
          Riymay's system will flag any AI-altered or digitally manipulated images.
        </p>
        <p>For any concerns or questions, we're always here to help.</p>
      </div>
    </div>
  );
};

export default Refunds;
